<template>
  <div class="grey lighten-4">
    <v-radio-group
      v-model="uploadType"
      v-on:click="reset"
      row
    >
      <v-radio label="Upload Regular Files" value="regular-form"></v-radio>
      <!-- <v-radio label="Upload Bank Statements" value="bank-statement-form"></v-radio> -->
      <v-radio label="Upload Funding Package" value="funding-package-form"></v-radio>
    </v-radio-group>

    <v-form onsubmit="return false;" ref="form" lazy-validation v-if="uploadType.length > 0">
      <v-flex xs12 sm12 md12>
        <div
          class="large-12 medium-12 small-12 filezone"
          v-if="uploadType !== 'submission-package-form'"
        >
          <input type="file" id="files" ref="files" multiple v-on:input="handleFiles()" />
          <p>
            Drop your files here
            <br />or click to search
          </p>
        </div>
       
        <div v-for="(file, key) in files" class="file-listing" :key="key">
          <!-- <v-layout row wrap v-if="uploadType == 'bank-statement-form'" class="px-3">
            <v-flex xs12 sm6 md6>
              <img
                v-if="file.fileUploaded.type == 'image/png'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpeg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/gif'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <p>
                {{file.fileUploaded.name}}
                <file-preview
                  v-if="file.fileUploaded.type == 'application/pdf'"
                  :file="file.fileData"
                ></file-preview>
              </p>
               <v-autocomplete
                v-model="file.bank_account_id"
                :rules="[v => !!v || 'Bank Account is required']"
                :items="bankAccounts"
                item-text="bank_account_name"
                item-value="id"
                label="Select Bank Account"
                persistent-hint
                required
                style="width:250px;"
                autocomplete
              ></v-autocomplete> 
            </v-flex>
            <v-flex xs12 sm6 md6 class="pl-3 hidden-xs-only">
              <v-date-picker
                v-model="file.bank_stm_month_year"
                :rules="[v => !!v || 'Month Year is required']"
                type="month"
                color="blue lighten-1"
                header-color="primary"
                label="Select Month and Year for Bank Stm"
                persistent-hint
                required
                no-title
                width="200"
                height="140px;"
                show-current="false"
                class="monthpicker"
              ></v-date-picker>
            </v-flex>
          </v-layout> -->

          <v-layout row wrap v-if="uploadType == 'regular-form'" class="px-3">
            <v-flex xs12 sm6 md6>
              <img
                v-if="file.fileUploaded.type == 'image/png'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpeg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/gif'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <p>
                {{file.fileUploaded.name}}
                <file-preview
                  v-if="file.fileUploaded.type == 'application/pdf'"
                  :file="file.fileData"
                ></file-preview>
              </p>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                v-model="file.category_id"
                :rules="[v => !!v || 'File Category is required']"
                :items="categories"
                item-text="file_category_name"
                item-value="id"
                label="File Category"
                persistent-hint
                required
                autocomplete
                name="fileCat"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else-if="uploadType == 'funding-package-form'" class="px-3">
            <v-flex xs12 sm6 md6>
              <img
                v-if="file.fileUploaded.type == 'image/png'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/jpeg'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <img
                v-else-if="file.fileUploaded.type == 'image/gif'"
                class="preview"
                v-bind:ref="'preview'+parseInt(key)"
                height="70"
                width="100"
              />
              <p>
                {{file.fileUploaded.name}}
                <file-preview
                  v-if="file.fileUploaded.type == 'application/pdf'"
                  :file="file.fileData"
                ></file-preview>
              </p>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                v-model="file.category_id"
                :rules="[v => !!v || 'File Category is required']"
                :items="categories"
                item-text="file_category_name"
                item-value="id"
                label="File Category"
                persistent-hint
                required
                autocomplete
                name="fileCat"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <div class="success-container" v-if="file.id > 0">Success</div>
          <div class="remove-container" v-else>
            <a class="remove" v-on:click="removeFile(key)">Remove</a>
          </div>
        </div>
      </v-flex>
    </v-form>
    <progress-model v-if="progressModel"></progress-model>
  </div>
</template>

<script>
import FilePreview from "./FilePreview.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import {URL} from '../../../env'

export default {
    // props: {
    //     deal: {
    //         type: Object,
    //         default: function() {
    //             return {};
    //         }
    //     }
    // },
  components: {
    // ProgressModel,
    // BankAccountForm,
    // FileCategoryForm,
    FilePreview
  },
  data() {
    return {
      deal: {},
      progressModel: false,
      uploaded: false,
      uploadType: "",
      category_id: null,
      notify_underwriter: false,
      files: [],
      image: "",
      bankAccounts: []

    };
  },
  computed: {
    // ...mapGetters({
    //   bankAccounts: "companies/fcsBankAccounts",
    // }),
    user_id() {
      return localStorage.getItem("user_id");
    }
  },
  mounted() {
    this.getFileCategories();
  },
  methods: {
    submitSelectedFileSection(created_deal){
      this.deal = created_deal
      // if(this.uploadType == 'bank-statement-form')
      //   this.submitBankStmFiles()
      if(this.uploadType == 'regular-form')
        this.submitFiles()
      else if(this.uploadType == 'funding-package-form')
        this.submitFundingFiles()
    },
    async getFileCategories() {
      await axios.get(`${URL}/api/get_file_category`).then(res => {
        this.categories = res.data;
      });
    },
    reset() {
      this.files = [];
      this.category_id = null;
    },
    handleFiles() {
      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          fileUploaded: uploadedFiles[i],
          category_id: null,
          fileData: null,
          bank_account_id: null,
          bank_stm_month_year: new Date().toISOString().substr(0, 10)
        });
      }
      this.$refs.files.value = null;
      this.getImagePreviews();
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].fileUploaded.name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function() {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i].fileUploaded);
        } else if (/\.(pdf)$/i.test(this.files[i].fileUploaded.name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function() {
              this.files[i].fileUploaded.fileData = reader.result;
              this.files[i].fileData = reader.result;
              this.passURL(reader.result, i);
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i].fileUploaded);
        } else {
          this.$nextTick(function() {
            if (
              this.$refs &&
              this.$refs["preview" + parseInt(i)] &&
              this.$refs["preview" + parseInt(i)].length > 0
            )
              this.$refs["preview" + parseInt(i)][0].src =
                "https://www.foot.com/wp-content/uploads/2017/03/placeholder.gif";
          });
        }
      }
    },
    passURL(dataURL, i) {
      let uploadedFiles = this.$refs.files.files;
      this.files[i].fileUploaded.fileData = dataURL;
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    submitFundingFiles: async function() {
      let vm = this;
      this.progressModel = true;
      if (this.$refs.form.validate()) {
        vm.progressModel = true;

        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].fileUploaded.id) {
            continue;
          }
          let formData = new FormData();
          formData.append("file", this.files[i].fileUploaded);
          formData.append("user_id", this.user_id);
          formData.append("company_id", this.deal.company_id);
          formData.append("file_category_id", this.files[i].category_id);
          formData.append(
            "notify_underwriter",
            this.notify_underwriter ? "ON" : "OFF"
          );

        //   this.$store
        //     .dispatch("companies/createDealFiles", { formData, headers: {}, i })
            axios.post(
				`${URL}/api/create_funding_package`,
				formData,
				{}
			)
            .then(data => {})
            .catch(data => {
              vm.progressModel = false;
              this.files = [];
              vm.flash("Error Adding File.", "error", {
                timeout: 3000
              });
            });
        }
        if (vm.uploaded) {
          vm.saveNote();
        }
        vm.progressModel = false;
        vm.files = [];
      }
    },
    submitFiles: async function() {
      let vm = this;
      this.progressModel = true;
      if (this.$refs.form.validate()) {
        vm.progressModel = true;
        for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].fileUploaded.id) {
            continue;
          }
          let formData = new FormData();
          formData.append("file", this.files[i].fileUploaded);
          formData.append("user_id", this.user_id);
          formData.append("deal_id", this.deal.id);
          formData.append("file_category_id", this.files[i].category_id);
          formData.append(
            "notify_underwriter",
            this.notify_underwriter ? "ON" : "OFF"
          );
          axios
            .post(`${URL}/api/create_deal_file`, formData)
            .then(data => {
              if (data.data.success) {
                vm.flash(data.data.message, "success", {
                  timeout: 3000
                });
                vm.progressModel = false;
                vm.uploaded = true;
                this.files = [];
              }
            })
            .catch(data => {
              vm.progressModel = false;
              this.files = [];
              vm.flash("Error Adding File.", "error", {
                timeout: 3000
              });
            });
        }
        if (vm.uploaded) {
          vm.saveNote();
        }
        vm.progressModel = false;
        vm.files = [];
      }
    },
    // submitBankStmFiles: async function() {
    //   let vm = this;
    //   if (this.$refs.form.validate()) {
    //     vm.progressModel = true;

    //     for (let i = 0; i < this.files.length; i++) {
    //       if (this.files[i].fileUploaded.id) {
    //         continue;
    //       }
    //       let formData = new FormData();
    //       formData.append("file", this.files[i].fileUploaded);
    //       formData.append(
    //         "bank_stm_month_year",
    //         this.files[i].bank_stm_month_year
    //       );
    //       formData.append("month_name", this.files[i].bank_stm_month_year);
    //       formData.append("bank_account_id", null);
    //       formData.append("company_id", this.deal.company_id);
    //       formData.append("user_id", this.user_id);
    //       formData.append("calculate_row", 0);
    //       formData.append("month_number", 0);
    //       formData.append("month_deposit_amount", 0);
    //       formData.append("month_number_of_deposits", 0);
    //       formData.append("month_negative_days", 0);
    //       formData.append("month_average_balance", 0);
    //       formData.append("month_transfer_amount", 0);
    //       formData.append("month_other_advances", 0);
    //       formData.append("month_net_deposits", 0);
    //       formData.append("month_monthly_ending_balance", 0);
    //       formData.append("month_monthly_beginning_balance", 0);
    //       formData.append("month_cc_number_of_sales", 0);
    //       formData.append("month_cc_sales", 0);
    //       formData.append("month_deduction", 0);
    //       formData.append("month_year", 0);
    //       formData.append("number_of_months", 0);
    //       formData.append(
    //         "notify_underwriter",
    //         this.notify_underwriter ? "ON" : "OFF"
    //       );
       
    //       axios.post(
		// 		    "/api/create_fcs_bank_statements",
		// 		    formData,
    //             {
    //                 "Content-Type": "multipart/form-data"
    //             }
		// 	)
    //         .then(
    //           function(data) {
    //             vm.progressModel = false;
    //             if (data.data.success) {
    //               vm.flash(data.data.message, "success", {
    //                 timeout: 3000
    //               });
    //               vm.uploaded = true;
    //             }
    //           }.bind(this)
    //         )
    //         .catch(function(data) {
    //           vm.flash("Error Adding File.", "error", {
    //             timeout: 3000
    //           });
    //         });
    //     }
    //     if (vm.uploaded) {
    //       vm.saveNote();
    //     }
    //     vm.progressModel = false;
    //     vm.files = [];
    //   }
    // },
    saveNote() {
      let app = this;
      axios
        .post(`${URL}/api/create_sub_note`, {
          deal_id: app.deal.id,
          user_id: app.user_id,
          deal_user_note: "Uploaded File(s)",
          deal_note_processor_role: "iso",
          deal_note_type: "Activity",
          pinned: false
        })
        .then(response => {
          if (response.data.success) {
            app.flash(response.data.message, "success", { timeout: 3000 });
          }
        })
        .catch(function(error) {
          app.flash("Error Adding Note", "error", { timeout: 3000 });
        });
    }
  }
};
</script>

<style scoped>
input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.filezone {
  outline: 2px dashed #2196f3;
  outline-offset: -10px;
  /*background: #ccc;*/
  background: #fafafa;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.filezone:hover {
  background: #eeeeee;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 50px 50px 50px;
}

div.file-listing img {
  max-width: 90%;
}

div.file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img {
  height: 100px;
}

div.success-container {
  text-align: center;
  color: green;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}
</style>

<style scoped>
.fileUpload {
  position: relative;
  overflow: hidden;
  margin: 25px;
}

.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}

.v-date-picker-header {
  height: 14px;
  padding-bottom: 0px;
  padding-top: 0px;
  padding-left: 16px;
  padding-right: 16px;
  border-top-width: 0px;
  margin-top: 10px;
}
.uploadBankStatements {
  float: right;
}
.uploadFiles {
  float: right;
}

form.v-form {
  min-height: 285px;
}
</style>
